export const DISPATCH_SEARCH = 'DISPATCH_SEARCH';
export const CLEAN_SEARCH = 'CLEAN_SEARCH';
